import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../hooks/redux';
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import css from './EditIntegration.module.scss';
import { TState } from '../../types';
import { editIntegration } from '../../../../store/reducers/integrationSlice';
import { EActive, EBankStatus } from '../../../../store/reducers/enumTypes';

type TAddIntegration = {
  setState: React.Dispatch<React.SetStateAction<TState>>;
};

type TFields = {
  isActive: EActive;
  userName: string;
  password: string;
  clientSecret: string;
  extClientId: string;
};

export const EditIntegration = ({ setState }: TAddIntegration) => {
  const dispatch = useAppDispatch();
  const { loading, paramsId, intregrations } = useAppSelector((state) => state.integrationReducer);
  const selectedIntregration = intregrations?.find((item) => item.paramsId === paramsId);
  const defaultState = {
    isActive:
      selectedIntregration?.status === EBankStatus.ENABLED ? EActive.ACTIVE : EActive.DISABLED,
    userName: '',
    password: '',
    clientSecret: '',
    extClientId: '',
  };
  const [fields, setFields] = useState<TFields>(defaultState);

  if (loading) {
    return <CircularProgress />;
  }
  const saveIntegration = (props: Partial<TFields>) => {
    dispatch(editIntegration({ ...props, paramsId })).then((response) => {
      // @ts-ignore
      if (response?.payload?.paramsId) {
        setState(TState.INTEGRATIONS);
      }
    });
  };

  return (
    <section className={css.root}>
      <Input
        label="Connectivity Name"
        placeholder=""
        value={selectedIntregration?.name || ''}
        onChange={() => {}}
        disabled
      />
      <div className={css.credentials}>
        <div className={css.title}>Edit Connectivity</div>
        <Input
          label="Username"
          placeholder="Enter new username"
          value={fields.userName}
          onChange={(e) => setFields({ ...fields, userName: e.target.value })}
        />
        <Input
          label="Password"
          placeholder="Enter new password"
          type="password"
          value={fields.password}
          onChange={(e) => setFields({ ...fields, password: e.target.value })}
        />
        <Input
          label="Client ID"
          placeholder="Enter new Client ID"
          value={fields.extClientId}
          width="343px"
          onChange={(e) => setFields({ ...fields, extClientId: e.target.value })}
        />
        <Input
          label="Client Secret"
          placeholder="Enter new client secret"
          value={fields.clientSecret}
          width="343px"
          multiline
          rows={4}
          onChange={(e) => setFields({ ...fields, clientSecret: e.target.value })}
        />
      </div>

      <div className={css.save}>
        <Button
          color="error"
          onClick={() => {
            fields.isActive === EActive.ACTIVE ? saveIntegration({ isActive: EActive.DISABLED }) : setState(TState.INTEGRATIONS);
          }}
        >
          Disable
        </Button>
        <Button
          color="success"
          onClick={() => {
            fields.isActive === EActive.DISABLED ? saveIntegration({ isActive: EActive.ACTIVE }) : setState(TState.INTEGRATIONS);
          }}
        >
          Activate
        </Button>
        <Button onClick={() => saveIntegration(fields)}>Save</Button>
        <Button
          color="error"
          onClick={() => {
            setState(TState.INTEGRATIONS);
          }}
        >
          Cancel
        </Button>
      </div>
    </section>
  );
};
